import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const brushShapesFragment = `
    on ${QueryType.product} {
        brush {
            shapes {
                key
                value
            }
        }
    }
`;

export const brushShapesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: brushShapesFragment
    };
};
